/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class NotificationDetailsModel {
    getFixupPrototypeFunction() { return NotificationDetailsModel.fixupPrototype; }

    static newInstance(model: Partial<NotificationDetailsModel>): NotificationDetailsModel {
        let obj = Object.assign(new NotificationDetailsModel(), model);
        NotificationDetailsModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<NotificationDetailsModel>): NotificationDetailsModel {
        if (!model) return null;
        return NotificationDetailsModel.newInstance(<NotificationDetailsModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: NotificationDetailsModel) {
        if (!obj) return;

        models.NotificationDetailsModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: NotificationDetailsModel): boolean {
        Object.setPrototypeOf(obj, NotificationDetailsModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.notification_input) {
            models.NotificationInputModel.fixupPrototype(this.notification_input);
        }
    }

    /**
     * notification type like emails/ITSM/Webhook
     */
    notification_type: string;

    /**
     * Notification Input
     */
    notification_input: models.NotificationInputModel;

}
